<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
      <div>
        <!-- title  -->
        <h2 class="mb-1">{{ $t('Peržiūra') }}</h2>
        <v-row class="mb-0 pb-0">
          <v-col class="pb-0" cols="12" md="6">
            <el-PDF-viewer download :file="pdfFile" />
          </v-col>
        </v-row>
      </div>
      <!-- actions  -->
      <v-card-actions>
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <el-button
            tile
            icon="atgal"
            @click.native="back()"
            :loading="loading"
            title="Atgal"
          />
        </v-row>
      </v-card-actions>
  </v-container>
</template>

<script>

export default {
  name: 'JournalNotificationView',
  components: {},
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      pageloading: false,
      loading: false,
      pdfFile: {},
    }
  },
  computed: {
    getId() {
      return this.$route.params.id || null
    },
    previewRoute() {
      return `uploads/${this.getId}/download`
    },
    modeReadonly() {
      return false
    },
  },
  created() {
    this.getPdfFile()
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    getPdfFile() {
      this.pageloading = true
      this.$axios
        .get(this.previewRoute)
        .then((res) => {
            this.pdfFile = res.data
            this.pdfFile.original_filename = res.data.original_filename
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.pageloading = false
        })
    },
  },
}
</script>
<style lang="scss" scoped></style>
